import script from "./StudyRequirement.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyRequirement.vue?vue&type=script&setup=true&lang=js"

import "./StudyRequirement.vue?vue&type=style&index=0&id=00c2ef04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c2ef04"]])

export default __exports__